module.exports = __webpack_public_path__ + "static/Slider2-16915f83d1b6fa47050ce3f6657fe411.jpg";